import Community from '@src/pages/shared/community/Community';
import CommunityChannels from '@src/pages/shared/community/CommunityChannels';
import CommunityChatSearch from '@src/pages/shared/community/CommunityChatSearch';
import CommunityMembers from '@src/pages/shared/community/CommunityMembers';
import CommunityMembersDetail from '@src/pages/shared/community/CommunityMembersDetail';
import CommunityMembersInvitation from '@src/pages/shared/community/CommunityMembersInvitation';
import { responsiveStylesType } from '@src/types/responsiveStylesType';

type SharedRouteType = {
  path: string;
  title: string;
  description?: string;
  element: React.ReactElement;
  responsive: responsiveStylesType;
};

const communityPath = (suffix: string): string => {
  return `/community/${suffix}`;
};

export const SHARED_URL = {
  COMMUNITY_DEFAULT_CHANNEL: communityPath(''),
  COMMUNITY_CHANNEL_LIST: communityPath('channels'),
  COMMUNITY_CHANNEL: communityPath(':code'),
  COMMUNITY_CHANNEL_MEMBERS: communityPath(':code/members'),
  COMMUNITY_CHANNEL_MEMBERS_INVITATION: communityPath(':code/members/invitation'),
  COMMUNITY_CHANNEL_MEMBERS_DETAIL_TENANT: communityPath(':code/members/tenant/:id'),
  COMMUNITY_CHANNEL_MEMBERS_DETAIL_COMPANY: communityPath(':code/members/company/:id'),
  COMMUNITY_CHANNEL_CHAT_SEARCH: communityPath('chat/search'),
};

const sharedRoutes: SharedRouteType[] = [
  {
    path: SHARED_URL.COMMUNITY_DEFAULT_CHANNEL,
    // CMSの値を動的に出力
    title: '',
    description: import.meta.env.VITE_COMMUNITY_META_DESCRIPTION,
    element: <Community />,
    responsive: ['desktop', 'tablet', 'mobile'],
  },
  {
    path: SHARED_URL.COMMUNITY_CHANNEL_LIST,
    title: 'チャンネル一覧',
    element: <CommunityChannels />,
    responsive: ['desktop', 'tablet', 'mobile'],
  },
  {
    path: SHARED_URL.COMMUNITY_CHANNEL,
    // CMSの値を動的に出力
    title: '',
    description: import.meta.env.VITE_COMMUNITY_META_DESCRIPTION,
    element: <Community />,
    responsive: ['desktop', 'tablet', 'mobile'],
  },
  {
    path: SHARED_URL.COMMUNITY_CHANNEL_MEMBERS,
    title: 'チャンネル参加者一覧',
    element: <CommunityMembers />,
    responsive: ['desktop', 'tablet', 'mobile'],
  },
  {
    path: SHARED_URL.COMMUNITY_CHANNEL_MEMBERS_INVITATION,
    title: '参加者招待',
    element: <CommunityMembersInvitation />,
    responsive: ['desktop', 'tablet', 'mobile'],
  },
  {
    path: SHARED_URL.COMMUNITY_CHANNEL_MEMBERS_DETAIL_TENANT, // テナントユーザー用
    title: '参加者閲覧',
    element: <CommunityMembersDetail mode='tenant' />,
    responsive: ['desktop', 'tablet', 'mobile'],
  },
  {
    path: SHARED_URL.COMMUNITY_CHANNEL_MEMBERS_DETAIL_COMPANY, // 企業ユーザー用
    title: '参加者閲覧',
    element: <CommunityMembersDetail mode='company' />,
    responsive: ['desktop', 'tablet', 'mobile'],
  },
  {
    path: SHARED_URL.COMMUNITY_CHANNEL_CHAT_SEARCH,
    title: 'チャット検索',
    element: <CommunityChatSearch />,
    responsive: ['desktop', 'tablet', 'mobile'],
  },
];

export default sharedRoutes;
